import 'schemas/yupHelper';
import * as yup from 'yup';

export const IndividualCreationSchema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  manheimMail: yup
    .string()
    .required()
    .isCoxEmailValid(),
  manheimMobileTelephone: yup.string().required().isCoxPhoneValid(),
  roleName: yup.string().required(),
});
